const generateCropId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `crop-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
};

export const normalizeCropGeometryEntry = (item, fallbackId = null, fallbackSpotNumber = null) => {
  const isLegacyGeometry = !!item && typeof item === 'object' && typeof item.type === 'string' && item.coordinates !== undefined;
  const geometry = isLegacyGeometry ? item : item?.geometry || null;
  const id = !isLegacyGeometry && item?.id ? item.id : fallbackId || generateCropId();
  const rawSpotNumber = Number(item?.spot_number ?? item?.spotNumber);
  const spotNumber = Number.isInteger(rawSpotNumber) && rawSpotNumber > 0
    ? rawSpotNumber
    : fallbackSpotNumber;
  const rawPercent = isLegacyGeometry ? NaN : Number(item?.damage_percent ?? item?.damagePercent);
  const damagePercent = Number.isFinite(rawPercent) ? Math.max(0, Math.min(100, rawPercent)) : 100;
  const protectedSpecies = isLegacyGeometry
    ? false
    : Boolean(item?.protected_species ?? item?.protectedSpecies ?? false);

  return { geometry, id, spotNumber, damagePercent, protectedSpecies };
};

export const serializeCropGeometryEntry = ({ id, spotNumber, geometry, damagePercent, protectedSpecies }) => ({
  id,
  ...(Number.isInteger(Number(spotNumber)) && Number(spotNumber) > 0
    ? { spot_number: Number(spotNumber) }
    : {}),
  geometry,
  damage_percent: Number.isFinite(Number(damagePercent)) ? Number(damagePercent) : 100,
  protected_species: Boolean(protectedSpecies),
});
